import axios from 'axios';

export default axios.create({
    baseURL:'https://designdlr.com/Services/Hydro/public/api/',
    headers:{
        'Content-type': 'application/json',
    }
});
